import type { NextPage } from 'next';
import { CookieDisclaimerComponent, getStaticPropsNicho } from 'ui';

const CookieDisclaimer: NextPage = () => {
	return <CookieDisclaimerComponent name="AltairStudios" />;
};

export const getStaticProps = getStaticPropsNicho();
export default CookieDisclaimer;
